<div data-cy="choose-loyalty-program-step">
  <app-choose-loyalty-program-form></app-choose-loyalty-program-form>
</div>
